import * as React from "react";
import {none, option, Option} from "ts-option";
import IndividualContact from "../../model/contact/IndividualContact";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import InputWithIcon from "../../hiberUiKit/src/atoms/Input/InputWithIcon";
import DropDownWrapper from "../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import {RootState} from "../../store/reducer/root/RootState";
import {getIndividualContact} from "../../store/view/contact";
import Toast from "../helper/Toast";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {editIndividualContact} from "../../store/action/contacts/contacts";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import InfoModule from "../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import Loading from "../ui/loading/Loading";
import {TitleSelector} from "./form/ContactTitleEditor";
import Job from "../../model/job/Job";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>;
}

interface ReduxProps {
	contact: Option<IndividualContact>
}

interface DispatchProps {
	editIndividualContact: (contact: IndividualContact) => void
}

interface IState {
	dropDownVisible: boolean
}

type Props = ComponentProps & ReduxProps & DispatchProps

class JobContactTitle extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.state = {dropDownVisible: false};
	}

	render() {
		return (
			<InfoModule icon={Icon.Phone} title={"TITLE"}>
				<Loading isLoading={this.props.job.map(j => j.data.principalContactId).isDefined && this.props.contact.isEmpty}>
					<div className={"c-job-contact-title reset-dropdown-right"}>
						<InputWithIcon type={"text"}
									   value={this.props.contact.flatMap(c => c.data.mainData.title).getOrElse("")}
									   placeholder={"Customer title"}
									   clearable={true}
									   onClearClick={() => this.updateTitle(none)}
									   onFocus={() => this.setState({dropDownVisible: true})}/>
						{this.state.dropDownVisible &&
						<DropDownWrapper onOutsideClick={() => this.setState({dropDownVisible: false})}>
							<TitleSelector onSelect={this.onSelect}/>
						</DropDownWrapper>
						}
					</div>
				</Loading>
			</InfoModule>
		);
	}


	updateTitle(title: Option<string>) {
		this.props.contact.map(
			c => {
				const updatedContact = c.copy({data: c.data.copy({mainData: c.data.mainData.copy({title})})});
				this.props.editIndividualContact(updatedContact)
			})
	}

	/**
	 * On select title.
	 * @param title
	 */
	onSelect(title: string) {
		this.setState({dropDownVisible: false}, () => {
			this.updateTitle(option(title))
		});
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		contact: props.job.map(j => j.data.principalContactId).flatMap(cId => getIndividualContact(cId, state))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editIndividualContact: (contact: IndividualContact) => dispatch(
			editIndividualContact(
				contact,
				none,
				false,
				() => Toast.success("Customer updated", "Customer details update"),
				(err) => notifyBugsnagAndShowToast(err, "Customer details update"))
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobContactTitle)